import { LayoutOrientation }            from './layout-orientation.model';
import { LabelPosition }                from './label-position.model';
import { WidgetCollection }             from './widget-collection.model';
import { WidgetInfo }                   from './widget-info.model';
import { getPropertyOf, hasPropertyOf } from '@cs/core/utils';


export class FormLayoutWidgetCollection<T> {

	/**
	 * Identification of the form
	 */
	id: string;
	/**
	 * Name to show in the UI
	 */
	label: string;
	/**
	 * Render direction of the form elements
	 */
	orientation: LayoutOrientation;
	/**
	 * Flag to show the collections label
	 */
	showLabel = true;

	/**
	 * Override label position for this collection (top or left)
	 * If not set, uses the form's default labelPosition
	 */
	labelPosition?: LabelPosition;

	widgets: WidgetInfo<T>[];
	/**
	 * Include in rendering
	 */
	include: boolean;

	constructor(init: Partial<WidgetCollection>, include: boolean = true) {
		this.id            = getPropertyOf(init, 'id');
		this.label         = getPropertyOf(init, 'label');
		this.showLabel     = getPropertyOf(init, 'showLabel', true);
		this.include       = include;
		this.labelPosition = getPropertyOf(init, 'labelPosition', null);

		this.orientation = hasPropertyOf(init, 'orientation')
			? init.orientation.toLowerCase() as LayoutOrientation : LayoutOrientation.Horizontal;
	}
}
